import { put, call, takeLatest } from 'redux-saga/effects';
import { actions } from './Reducer';
import {
  getCustomersSuccessAction,
  getCustomerSuccessAction,
  createCustomerSuccessAction,
  setCustomersIsLoadingAction,
  setCustomersCountAction,
  deleteCustomerSuccessAction,
  updateCustomerSuccessAction,
} from './Actions';
import {
  newErrorNotificationAction,
  newSuccessNotificationAction,
  errorNotificationFromError,
} from '../notifications/Actions';
import * as api from './Api';

import { push } from 'connected-react-router';
import { setRedirectFalse, setRedirectTrue } from '../globalFail/Action';

function* createCustomer({ payload, noRedirect }) {
  yield put(setRedirectFalse());
  try {
    yield put(setCustomersIsLoadingAction(true));

    // const response = yield call(api.createCustomer, payload);
    // const { data } = response;
    // const customer = data;
    // yield put(createCustomerSuccessAction(customer));
    // yield put(newSuccessNotificationAction('Customer Created'));
    // yield put(setGlobalFail(false))
    // yield put(setRedirectTrue());
    console.log(noRedirect)
    if (noRedirect === true) {
      const response = yield call(api.createCustomer, payload);
      const { data } = response;
      const customer = data;
      yield put(createCustomerSuccessAction(customer));
      yield put(newSuccessNotificationAction('Customer Created'));
      // yield put(setGlobalFail(false))
      yield put(setRedirectTrue());
    } else {
      const response = yield call(api.createStagingCustomer, payload);
      const { data } = response;
      const customer = data;
      // yield put(createCustomerSuccessAction(customer));
      yield put(newSuccessNotificationAction('Customer Created! Pending'));
      console.log('alskdfjlaks')
    }
  } catch (error) {
    yield put(errorNotificationFromError(error));
    // yield put(setGlobalFail(true))
    yield put(setRedirectFalse());
  } finally {
    yield put(setCustomersIsLoadingAction(false));
  }
}

function* updateCustomerLimit({ payload }) {
  try {
    yield call(api.updateCustomerLimit, payload);
    yield put(newSuccessNotificationAction('Limits Updated'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  }
}

function* updateCustomer({ payload }) {
  const { formData, id } = payload;

  try {
    yield put(setCustomersIsLoadingAction(true));

    const response = yield call(api.updateCustomer, id, formData);

    const { data } = response;
    const customer = data;

    yield put(updateCustomerSuccessAction(customer));

    yield put(newSuccessNotificationAction('Customer Updated'));
    // yield put(push('/customers'))
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setCustomersIsLoadingAction(false));
  }
}

function* getCustomer({ payload }) {
  const customerId = payload;

  try {
    yield put(setCustomersIsLoadingAction(true));

    const response = yield call(api.getCustomer, customerId);

    const { data } = response;
    const customer = data;

    yield put(getCustomerSuccessAction(customer));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setCustomersIsLoadingAction(false));
  }
}

/* 
function* deleteCustomer({ payload }) {
  try {
    yield put(setCustomersIsLoadingAction(true));
    yield call(api.deleteCustomer , payload);  

    yield put(deleteCustomerSuccessAction(payload))
    yield put(newSuccessNotificationAction('Customer Deleted'))
  } catch (error) {
    yield put(newErrorNotificationAction(error));
  } finally {
    yield put(setCustomersIsLoadingAction(false));
  }
}
 */

function* getCustomers({ payload }) {
  const defData = {
    offset: 0,
    size: 10,
    searchTerm: '',
    filterBy: [],
    filterCountry: '',
    sort: 'businessName',
    dir: 'asc',
  };

  const body = { ...defData, ...payload };

  try {
    yield put(setCustomersIsLoadingAction(true));
    const response = yield call(api.getCustomers, body);
    const data = response.data;

    const count = data.count;
    const customers = data.content;

    yield put(setCustomersCountAction(count));
    yield put(getCustomersSuccessAction(customers));
  } catch (error) {
    yield put(newErrorNotificationAction(error));
  } finally {
    yield put(setCustomersIsLoadingAction(false));
  }
}

export default function*() {
  // yield takeLatest(actions.DELETE_CUSTOMER, deleteCustomer);
  yield takeLatest(actions.CREATE_CUSTOMER, createCustomer);
  yield takeLatest(actions.UPDATE_CUSTOMER, updateCustomer);
  yield takeLatest(actions.GET_CUSTOMER, getCustomer);

  yield takeLatest(actions.GET_CUSTOMERS, getCustomers);
  yield takeLatest(actions.UPDATE_CUSTOMER_LIMIT, updateCustomerLimit);
}
